export default "__VITE_ASSET__CM774KCZ__"